module.exports = __webpack_public_path__ + "static/media/promo-lovelook.7595beb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-lovelook.jpg
// module id = 313
// module chunks = 0